import { TextPropsTypes } from "../TextPropsTypes";
import "../SCSS/styles.css";
import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";
import { UpdaptTextArea } from "@updapt/updapt-core";

function TextBox({
  questionId,
  surveyAnswers,
  isPreview,
  handleChangeInputSingleText,
  surveyAnswersInfo,
}: TextPropsTypes) {
  return (
    <div className="supplier-view-single-text-cover">
      <UpdaptTextArea
        styles={{
          input: {
            width: "650px",
            minHeight: "107px",
          },
        }}
        disabled={
          isPreview ||
          surveyAnswers?.[questionId!]?.notApplicableInfo?.isNotApplicable ||
          surveyAnswersInfo?.surveyStatus === EnumSurveyAnswerStatus?.COMPLETED
        }
        placeholder="Please enter text"
        onChange={(e) =>
          surveyAnswersInfo?.surveyStatus !==
            EnumSurveyAnswerStatus?.COMPLETED &&
          !surveyAnswers?.[questionId!]?.notApplicableInfo?.isNotApplicable &&
          handleChangeInputSingleText!(questionId, e)
        }
        value={surveyAnswers?.[questionId]?.val ?? ""}
      />
    </div>
  );
}

export default TextBox;
